// extracted by mini-css-extract-plugin
export default {"contentMain":"ErrorModal_contentMain__LZXag","closeButton":"ErrorModal_closeButton__+KWIm"};